import { format, parseISO } from 'date-fns';

export interface ItineraryStartTimeProps {
  startTime: any;
}

const ItineraryStartTime = ({ startTime }: ItineraryStartTimeProps) => {
  const formattedStartTime = format(parseISO(startTime), 'HH:mm');
  return (
    <div className="mt-2">
      <span>Starting Time</span>
      <div className="mt-2 w-full rounded-sm bg-muted-white p-1 text-center dark:bg-design-secondary-black dark:text-white">
        {formattedStartTime}
      </div>
    </div>
  );
};

export default ItineraryStartTime;
